import React, { useState } from 'react';
import axios from 'axios';

const API_BASE = process.env.NODE_ENV === 'production'
  ? 'https://admin.highperformr.ai'
  : 'http://localhost:4000';
const API = `${API_BASE}/api`;

const FeatureRequestSubmit = () => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [issueUrl, setIssueUrl] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setIssueUrl(null);
    if (!title.trim()) {
      setError('Title is required.');
      return;
    }
    setSubmitting(true);
    try {
      const response = await axios.post(
        `${API}/feature-request`,
        { title: title.trim(), description: (description || '').trim() },
        { withCredentials: true }
      );
      setSuccess('Feature request created successfully.');
      setIssueUrl(response.data.issueUrl);
      setTitle('');
      setDescription('');
    } catch (err) {
      const message = err.response?.data?.error || err.message || 'Failed to create feature request.';
      setError(message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ padding: '30px', maxWidth: '700px' }}>
      <h2 style={{ margin: '0 0 20px 0', fontSize: '24px', color: '#2c3e50' }}>
        Raise a feature request
      </h2>
      <p style={{ color: '#666', marginBottom: '24px' }}>
        Submit a feature request. A GitHub issue will be created and you can track it there.
      </p>

      <form onSubmit={handleSubmit} style={{
        backgroundColor: 'white',
        padding: '24px',
        borderRadius: '8px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}>
        <div style={{ marginBottom: '16px' }}>
          <label htmlFor="title" style={{ display: 'block', marginBottom: '6px', fontWeight: '600', color: '#333' }}>
            Title *
          </label>
          <input
            id="title"
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Short title for the feature"
            disabled={submitting}
            style={{
              width: '100%',
              padding: '10px 12px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '14px',
              boxSizing: 'border-box'
            }}
          />
        </div>
        <div style={{ marginBottom: '20px' }}>
          <label htmlFor="description" style={{ display: 'block', marginBottom: '6px', fontWeight: '600', color: '#333' }}>
            Description
          </label>
          <textarea
            id="description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Describe the feature in detail..."
            disabled={submitting}
            rows={5}
            style={{
              width: '100%',
              padding: '10px 12px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '14px',
              resize: 'vertical',
              boxSizing: 'border-box'
            }}
          />
        </div>
        {error && (
          <div style={{
            backgroundColor: '#f8d7da',
            color: '#721c24',
            padding: '12px',
            borderRadius: '4px',
            marginBottom: '16px'
          }}>
            {error}
          </div>
        )}
        {success && (
          <div style={{
            backgroundColor: '#d4edda',
            color: '#155724',
            padding: '12px',
            borderRadius: '4px',
            marginBottom: '16px'
          }}>
            {success}
            {issueUrl && (
              <p style={{ margin: '8px 0 0 0' }}>
                <a href={issueUrl} target="_blank" rel="noopener noreferrer" style={{ color: '#155724', fontWeight: '600' }}>
                  Open issue on GitHub →
                </a>
              </p>
            )}
          </div>
        )}
        <button
          type="submit"
          disabled={submitting}
          style={{
            padding: '10px 20px',
            backgroundColor: submitting ? '#95a5a6' : '#3498db',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            fontSize: '14px',
            fontWeight: '600',
            cursor: submitting ? 'not-allowed' : 'pointer'
          }}
        >
          {submitting ? 'Submitting...' : 'Submit feature request'}
        </button>
      </form>
    </div>
  );
};

export default FeatureRequestSubmit;
